/* ============================================================
   MB CLEANINGS — Premium cursor
   ------------------------------------------------------------
   Gouden dot die de muis volgt. Op interactieve elementen
   wordt de dot groter + glow.
   Uitgeschakeld op touch devices en reduced-motion.
   ============================================================ */
(function() {
    if (!window.matchMedia) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var dot = document.createElement('div');
    dot.className = 'mbc-cursor-dot';
    dot.setAttribute('aria-hidden', 'true');
    document.body.appendChild(dot);
    document.body.classList.add('mbc-cursor-enabled');

    var visible = false;

    window.addEventListener('pointermove', function(e) {
        dot.style.transform = 'translate3d(' + e.clientX + 'px, ' + e.clientY + 'px, 0) translate(-50%, -50%)';
        if (!visible) {
            dot.classList.add('is-visible');
            visible = true;
        }
    }, { passive: true });

    var interactiveSelector = 'a, button, [role="button"], input:not([type="hidden"]), textarea, select, label, .usp-card, .service-card, .review-card, .trust-card, .tile, .filter-pill';

    document.addEventListener('pointerover', function(e) {
        if (e.target.closest && e.target.closest(interactiveSelector)) {
            dot.classList.add('is-hovered');
        }
    });
    document.addEventListener('pointerout', function(e) {
        var from = e.target.closest ? e.target.closest(interactiveSelector) : null;
        var to = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest(interactiveSelector) : null;
        if (from && !to) {
            dot.classList.remove('is-hovered');
        }
    });

    document.addEventListener('mouseleave', function() {
        dot.classList.remove('is-visible');
        visible = false;
    });
    document.addEventListener('mouseenter', function() {
        dot.classList.add('is-visible');
        visible = true;
    });

    window.addEventListener('pointerdown', function() { dot.classList.add('is-pressed'); });
    window.addEventListener('pointerup', function() { dot.classList.remove('is-pressed'); });
})();
